import { UsuarioResponse } from "domain/types/usuario/usuarioResponse"

export const ALTERAR_PERFIL = 'ALTERAR_PERFIL'

export interface AuthPerfilState {
   perfilAtual : UsuarioResponse | undefined
}

export interface AlterarPerfilAction {
    type: typeof ALTERAR_PERFIL,
    payload: UsuarioResponse
}

export type AuthPerfilActionTypes = AlterarPerfilAction